const sm2 = require('sm-crypto').sm2
const cipherMode = 0 // 1 - C1C3C2，0 - C1C2C3，默认为1
const publicKey = '048d93a61ac71c5cb84213c80a4b8d54a1fcdc71e1caf39e7660c0fe7abab3281b2122ac353863adb8022000d250e82becb0149f1705038439d20f9f971499eeca'
const secretKey = 'dd28045d81078de354ac55980350b9e4acbe9cd7ae7cd4c35b061d2f16bdda50'

// 加密
export function encrypt (txt) {
  const encryptData = sm2.doEncrypt(txt, publicKey, cipherMode) // 加密结果
  return '04' + encryptData
}

// 解密
export function decrypt (txt) {
  const data = txt.substring(2)
  const decryptData = sm2.doDecrypt(data, secretKey, cipherMode)
  return decryptData
}
